module.exports = __webpack_public_path__ + "img/bcd.8d9162d4.png";